define(['edge/platform/base/BaseCtrl', 'underscore'], (BaseCtrl, _)=> {
    const fn = ($scope, $state, $rootScope, $filter, ModalService,  AgeAllowedToDrive, submissionViewModel, StateUtils, LocaleService, MembershipService, InputValidationService)=> {

        const ctrl = Object.create(BaseCtrl);

        const flowModel = StateUtils.activeDataForState(true).flowModel;
        const submissionVM = submissionViewModel();

        ctrl.init = ()=> {
            //^Princy
            // $scope.source_string = 'parvez.alam';
            // console.log('source String = ' + $scope.source_string);
            // var encrypted = CryptoJS.AES.encrypt(
            //             $scope.source_string,
            //             $rootScope.base64Key,
            //             { iv: $rootScope.iv });
            // console.log('encrypted = ' + encrypted);
            $scope.isNameValid = true;////ENHC0013007 -- Insurance Premium Refunds --Arpita
            //DFCT0020397 - QnB Date Of Birth Validation -Arpita
            $scope.minDob = "01-01-1800";
            $scope.isMinDateOfBirthValid = true;
           //DFCT0020397 - QnB Date Of Birth Validation ends
            $scope.isPeriodStartDateValid = true;
            $scope.addressOverridden = false
//            $rootScope.xxx = false
            // ENHC0011961 -  initializing membership scope --Arpita Sengupta
            $scope.accountHolder = submissionVM.draftData.accountHolder.value;
            $scope.membershipDetails={
                membershipNumber : $scope.accountHolder.membershipNumber || '',
                firstName : '',
                lastName : ''
            };
            // ENHC0011961 - assigning membershipnumber if available
            if($scope.submission.draftData.accountHolder.membershipNumber){
                $scope.membershipDetails.membershipNumber = $scope.submission.draftData.accountHolder.membershipNumber
            }
            //ended
    $scope.phoneMask = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9');

            const today = new Date();
            //This function is used to remove prefill data needed to obtain a quote for streamlined submissions.
            const sanitisePrefillDataFromQuickQuote = (accountHolder) => {
                if (accountHolder.firstName === '0streamlinedquote0') {
                    accountHolder.firstName = undefined;
                    accountHolder.lastName = undefined;
                    accountHolder.dateOfBirth = undefined;
                }
            };

            $scope.submissionVm = submissionViewModel();
            
            //Added for Cancel button on Personal Information
            //screen of Personal Auto - 10011- GW-QB-Quote-My information_AUTO
            $scope.goToCancel = (form) => {
                if ($scope.cancel) {
                    $scope.cancel((_model, args) => flowModel.cancel(_model, args), form);
                } else {
                    flowModel.cancel(model);
                }
            };

    $scope.submissionVM = submissionVM;

            $scope.accountHolder = $scope.submissionVm.draftData.accountHolder.value;
            //Added for the defect DE1321
            $scope.accountCellNumber = $scope.accountHolder.cellNumber;
            $scope.accountWorkNumber = $scope.accountHolder.workNumber;
            $scope.accountHomeNumber = $scope.accountHolder.homeNumber;

            //ENHC0012832 - North Carolina Property Rate Review effective 02/01/2024
            // Not display occupation typecodes from this list
            $scope.occupationFilterCodes = ["studentawaymorethan100mi"];

            //Added for defect DE823
            if($scope.accountHolder.primaryPhoneType == "mobile"){
                $scope.submissionVM.draftData.accountHolder.homeNumber = $scope.accountHolder.cellNumber;
            }else if($scope.accountHolder.primaryPhoneType == "home") {
                $scope.submissionVM.draftData.accountHolder.homeNumber = $scope.accountHolder.homeNumber;
            }else if($scope.accountHolder.primaryPhoneType == "work") {
                $scope.submissionVM.draftData.accountHolder.homeNumber = $scope.accountHolder.workNumber;
            }
            // DFCT0021660-phone no display issue
            if($scope.submissionVm.draftData.accountHolder.value.homeNumber && $scope.submissionVm.draftData.accountHolder.value.homeNumber.length>10){
                $scope.submissionVm.draftData.accountHolder.value.homeNumber = $scope.submissionVm.draftData.accountHolder.value.homeNumber.slice($scope.submissionVm.draftData.accountHolder.value.homeNumber.length-10)
            }else if($scope.submissionVm.draftData.accountHolder.value.cellNumber && $scope.submissionVm.draftData.accountHolder.value.cellNumber.length>10){
                $scope.submissionVm.draftData.accountHolder.value.cellNumber = $scope.submissionVm.draftData.accountHolder.value.cellNumber.slice($scope.submissionVm.draftData.accountHolder.value.cellNumber.length-10)
            }else if($scope.submissionVm.draftData.accountHolder.value.workNumber && $scope.submissionVm.draftData.accountHolder.value.workNumber.length>10){
                $scope.submissionVm.draftData.accountHolder.value.workNumber = $scope.submissionVm.draftData.accountHolder.value.workNumber.slice($scope.submissionVm.draftData.accountHolder.value.workNumber.length-10)
            }//ended
             // adding function to update period start date --Arpita Sengupta
            $scope.submissionVM.draftData.periodStartDate.value = $scope.submissionVm.draftData.periodStartDate.value ? $scope.submissionVm.draftData.periodStartDate.value : today;
            let startDt = new Date($scope.submissionVm.draftData.periodStartDate.value);
            const effectiveDtManipulation = (addedDt) => {
                let defaultEffDt = Date.UTC(addedDt.getUTCFullYear(), addedDt.getUTCMonth(),
                    addedDt.getUTCDate(), addedDt.getUTCHours(),
                    addedDt.getUTCMinutes(), addedDt.getUTCSeconds()
                );
                $scope.submissionVm.draftData.periodStartDate.value = new Date(defaultEffDt);
            };

            if(!$scope.submissionVM.quoteID.value){
                startDt.setDate(startDt.getDate() + 7);
                effectiveDtManipulation(startDt);
            }
            //for quote retrieval
            if ($scope.submissionVM.quoteID.value && new Date(startDt).setHours(0,0,0,0) < new Date().setHours(0,0,0,0)) {
                let formtdt = new Date(today.toISOString());                
                formtdt.setDate(formtdt.getDate() + 7);
                effectiveDtManipulation(formtdt);
            }   
             //ended
            $scope.entryDate = $scope.submissionVm.draftData.periodStartDate.value;


        // CHG0031104 - Set QnB Source, Credit Union Member Flag and Credit Union Join year
        // AB - 05/14/2018

        // CHG0057320 - Add SEA & YOMTOB Inc. for QnB Links
        // AB - 11/23/2020

            if ($rootScope.Arg1 == null){
                var arg1 = $rootScope.Arg1
            }else{
                var arg1 = $rootScope.Arg1.toUpperCase()
            }

            switch(arg1){
                case "GORMISH":
                case "SEA":
                case "YOMTOB":
                case "SECU":
                case "BWE":
                case "SCOTT":
                case "MERRILL":
                case "CROWFIELD":
                case "RICKARD":
                case "NIXON":
                case "BLUE":
                case "GRAY":
                case "JONES":
                case "MCCARTHY":
                case "ASSOCIATES":
                case "ANTHONY":
                case "SIMMONS":
                case "WILLIAMS":
                case "MORRISON":
                case "CRUMEL":
                case "YOU":
                case "MILLER":
                case "PERSINSKI":
                case "FLOURNOY":
 //                 $scope.submissionVM.draftData.accountHolder.qnbSource = "SECU";
// Get Credit Union Member Flag and Credit Union Join year from the Membership page
// AB -  April 05, 2020
//                  $scope.submissionVM.draftData.accountHolder.isCreditUnionMember = true
//                  $scope.submissionVM.draftData.accountHolder.joinedYearCreditUnionMembership = (new Date()).getFullYear()
//                  break
//                  $scope.submissionVM.draftData.accountHolder.qnbSource = "GORMISH";
                  $scope.submissionVM.draftData.accountHolder.qnbSource = $rootScope.Arg1.toUpperCase()
                  break
                default:
//                  $scope.submissionVM.draftData.accountHolder.qnbSource = $rootScope.Arg1;
                  $scope.submissionVM.draftData.accountHolder.qnbSource = null;
            }

            sanitisePrefillDataFromQuickQuote($scope.accountHolder);

            //$scope.accountHolder.primaryPhoneType = null;
             $scope.submissionVM.draftData.accountHolder.value.primaryPhoneType = "home";
   
    $scope.submissionVM.draftData.accountHolder.value.ageLimit = 16;
            $scope.submissionVm.draftData.policyAddress.addressType.value = $scope.submissionVm.draftData.policyAddress.addressType.value || 'home';
            
            $scope.maxDateOfBirth = {
                year: today.getFullYear() - AgeAllowedToDrive,
                month: today.getMonth(),
                day: today.getDate()
            };

            $scope.today = new Date();
            $scope.today.setHours(0, 0, 0, 0);


        $scope.coverageStartDt = today.setHours(720);
        /*current date from the Calendar fix by devendra start*/
        if(new Date().getTimezoneOffset() > 0){
            $scope.today.setHours(-1);
        }
        /*current date from the Calendar fix by devendra end*/
            // Check for the valid account holder details
            var isValidAccount = $scope.accountHolder["dateOfBirth"] ? true : false;
            //console.log("isValidAccount: ",isValidAccount);
            if (!isValidAccount) {

                var accountDetails = angular.copy($rootScope.accountDetails);
                var accountHolder = accountDetails.accountHolder;
                var accountHolderAddress = accountDetails.accountHolderAddress;
                // check account exists
                if (accountHolder.accountExists) {

                    // Fill Account Details
                    $scope.accountHolder.publicID = accountHolder.publicID;
                    $scope.accountHolder.accountNumber = accountHolder.accountNumber;
                    $scope.accountHolder.displayName = accountHolder.displayName;
                    $scope.accountHolder.accountExists = accountHolder.accountExists;
                    $scope.accountHolder.firstName = accountHolder.firstName;
                    $scope.accountHolder.lastName = accountHolder.lastName;
                    $scope.accountHolder.emailAddress1 = accountHolder.emailAddress1;
                    $scope.accountHolder.emailExist = true;
                    var dateOfBirth = accountHolder.dateOfBirth;
                    var day = parseInt($filter('date')(dateOfBirth, "dd"));
                    var month = parseInt($filter('date')(dateOfBirth, "MM")) - 1;
                    var year = parseInt($filter('date')(dateOfBirth, "yyyy"));
                    //console.log("DateOfBirth: ", day, month, year);
                    $scope.accountHolder.dateOfBirth = {
                        day : day,
                        month : month,
                        year : year
                    };
                    $scope.accountHolder.workNumber = accountHolder.workNumber;
                    $scope.accountHolder.homeNumber = accountHolder.homeNumber;
                    $scope.accountHolder.cellNumber = accountHolder.cellNumber;
                    //console.log("DateOfBirth: ",$scope.accountHolder.dateOfBirth);

                    // Fill Policy Address
                    $scope.submissionVm.draftData.policyAddress.addressLine1 = accountHolderAddress.addressLine1;
                    $scope.submissionVm.draftData.policyAddress.addressLine2 = accountHolderAddress.addressLine2;
                    $scope.submissionVm.draftData.policyAddress.addressLine3 = accountHolderAddress.addressLine3;
                    $scope.submissionVM.draftData.policyAddress.state = accountHolderAddress.state;
                    $scope.submissionVM.draftData.policyAddress.city = accountHolderAddress.city;

                    $scope.submissionVM.draftData.accountHolder.primaryPhoneType = accountHolder.primaryPhoneType;
                    var primaryPhType = $scope.submissionVM.draftData.accountHolder.primaryPhoneType;
                    if(primaryPhType && primaryPhType.value.code === "mobile"){
                        $scope.submissionVM.draftData.accountHolder.cellNumber = accountHolder.phoneNumber;
                    }else if(primaryPhType && primaryPhType.value.code === "home") {
                        $scope.submissionVM.draftData.accountHolder.homeNumber = accountHolder.phoneNumber;
                    }else if(primaryPhType && primaryPhType.value.code === "work") {
                        $scope.submissionVM.draftData.accountHolder.workNumber = accountHolder.phoneNumber;
                    }
                } else {
                    $scope.accountHolder.accountExists = accountHolder.accountExists;
                }

                // Remove accountDetails object from rootscope
                $rootScope.accountDetails = {
                    accountHolder : {
                        accountExists: false
                    }
                };

            }
        };
        //DFCT0020397 - QnB Date Of Birth Validation -Arpita
        ctrl.checkDate = function (){
            if($scope.submissionVM.draftData.accountHolder.dateOfBirth.value.year && ($scope.submissionVM.draftData.accountHolder.dateOfBirth.value.year < "1800")){
                $scope.isMinDateOfBirthValid = false
                $scope.submissionVM.draftData.accountHolder.dateOfBirth.value = ''
            }else{
                $scope.isMinDateOfBirthValid = true
            }
        }
        //DFCT0020397 - QnB Date Of Birth Validation ends

        $scope.$watch('submissionVm.draftData.accountHolder.dateOfBirth.value', () => {
            //console.log($scope.submissionVm.draftData.accountHolder.dateOfBirth.value);
            // When coming from a Streamlined Quote, ensure the driver DOB is in sync with the Account Holder
            if (angular.isDefined($scope.submissionVm.draftData.lobs.personalAuto)) {
                const drivers = $scope.submissionVm.draftData.lobs.personalAuto.drivers;
                if (drivers && drivers.length > 0) {
                    const slqDriver = _.findWhere(drivers.value, {licenseNumber: '0streamlinedquote0'});
                    if (angular.isDefined(slqDriver)) {
                        slqDriver.dateOfBirth = angular.copy($scope.submissionVm.draftData.accountHolder.dateOfBirth.value);
                    }
                }
            }
        });

        function validateInputs (inputsToValidate, scopeVar) {
            let inputValidationData = [];
            inputValidationData = InputValidationService.isInputValid(inputsToValidate)
            if(!inputValidationData[0] && inputValidationData[1].length > 0){
                for (let i=0; i<inputValidationData[1].length; i++){
                    scopeVar[inputValidationData[1][i]] = ''
                    $scope.isNameValid = false;
                }
            }else{
                $scope.isNameValid = true;
            }
        }
        //Added for Next button on Personal Information
        //screen of Personal Auto - 10011- GW-QB-Quote-My information_AUTO
        ctrl.displayDisclaimer = (form) => {

            // Changes for incident INC0019053 begins

            var currentDate = new Date();
            var diffOfDaysForBackDate = moment(currentDate).startOf('day').diff(moment($scope.submissionVM.draftData.periodStartDate.value).startOf('day'), 'days');
            const submissionVM = submissionViewModel();
            //ENHC0013007 -- Insurance Premium Refunds --Arpita
            let inputsToValidate = [
                {'firstName' : $scope.submissionVM.draftData.accountHolder.firstName.value},
                {'middleName' : $scope.submissionVM.draftData.accountHolder.middleName.value},
                {'lastName' : $scope.submissionVM.draftData.accountHolder.lastName.value}                
            ];
            let primaryAddInput = [
                {'addressLine1' : $scope.submissionVM.draftData.policyAddress.addressLine1.value},
                {'addressLine2' : $scope.submissionVM.draftData.policyAddress.addressLine2.value},
                {'city' : $scope.submissionVM.draftData.policyAddress.city.value}
            ]
            validateInputs(inputsToValidate,$scope.submissionVM.draftData.accountHolder.value)
            if(!$scope.isNameValid){
                return;
            }
            validateInputs(primaryAddInput,$scope.submissionVM.draftData.policyAddress.value)
            if(!$scope.isNameValid){
                return;
            }
            //ended

            // Period Start Date should not be back date
            if(diffOfDaysForBackDate >= 1){
                $scope.isPeriodStartDateValid = false;
                //$state.go('contactUs', {quoteID: (submissionVM) ? submissionVM.quoteID.value : null,errorMsg :submissionVM.draftData.lobs.value.exception });
                return;
            }

            var diffOfDaysForFutureDate = moment($scope.submissionVM.draftData.periodStartDate.value).startOf('day').diff(moment(currentDate).startOf('day'), 'days');
            if(diffOfDaysForFutureDate > 30){
                submissionVM.draftData.lobs.value = {};
                $scope.isPeriodStartDateValid = false;
                //$state.go('contactUs', {quoteID: (submissionVM) ? submissionVM.quoteID.value : null,errorMsg :submissionVM.draftData.lobs.value.exception });
                return;
            }
            
            var policyEnqDate = new Date($scope.entryDate);
            var diffOfDays = moment($scope.submissionVM.draftData.periodStartDate.value).startOf('day').diff(moment(policyEnqDate).startOf('day'), 'days');
            
            // Period Start Date should not be more than 30 days from date of quotation
            if(diffOfDays > 30){
                $scope.isPeriodStartDateValid = false;
                //$state.go('contactUs', {quoteID: (submissionVM) ? submissionVM.quoteID.value : null,errorMsg :submissionVM.draftData.lobs.value.exception });
                return;
            }
            
            // Changes for incident INC0019053 ends

            //DFCT0020397 - QnB Date Of Birth Validation -Arpita
            if($scope.submissionVM.draftData.accountHolder.dateOfBirth.value.year && ($scope.submissionVM.draftData.accountHolder.dateOfBirth.value.year < "1800")){
                $scope.isMinDateOfBirthValid = false
                $scope.submissionVM.draftData.accountHolder.dateOfBirth.value = '';
                return;
            }
            //DFCT0020397 - QnB Date Of Birth Validation ends
            
            var title = $filter('translate')('quoteandbind.ho.views.contact-details.informationdisclosure.heading')
            var message = $filter('translate')('quoteandbind.ho.views.contact-details.informationdisclosure.static')
            var continueModel = ModalService.showDisclaimer(title, message);
            continueModel.result.then(function(){ctrl.setNextState(form)}, function(){})
        };
        ctrl.next = function (form) {
            $scope.submissionVM.draftData.accountHolder.value.emailExist = true;
            //eodb part2 quote default as member --Arpita Sengupta
            if(!$scope.submissionVM.draftData.accountHolder.membershipNumber.value){
                $scope.submissionVM.draftData.accountHolder.quoteAsAAAMember.value = true;
                $scope.submissionVM.draftData.accountHolder.isMember.value = false
            }
            // ended
             if ($scope.submissionVm.draftData.policyAddress.value.county == "NA")
             {
                       $scope.submissionVM.draftData.accountHolder.isAddressOverridden = true
            }
            else {
                       $scope.submissionVM.draftData.accountHolder.isAddressOverridden = false
            }
            form.submitted = true;
           if($scope.submissionVM.draftData.accountHolder.value.emailAddress1 == undefined || $scope.submissionVM.draftData.accountHolder.value.emailAddress1 == ''){
                return false;
            }
            flowModel.next(submissionVM);

        };

        ctrl.cancel = function () {
            flowModel.cancel(submissionVM);
        };
        ctrl.setNextState= (form) => {

            /*if(!$scope.accountHolder.accountExists){
                $scope.submissionVM.draftData.accountHolder.value.primaryPhoneType = "home";
            }else{
                //Added for the defect DE1321
                $scope.submissionVM.draftData.accountHolder.value.primaryPhoneType = $scope.accountHolder.primaryPhoneType;
                $scope.submissionVM.draftData.accountHolder.cellNumber = $scope.accountCellNumber;
                $scope.submissionVM.draftData.accountHolder.homeNumber = $scope.accountHomeNumber;
                $scope.submissionVM.draftData.accountHolder.workNumber = $scope.accountWorkNumber;
            }*/
            //console.log("inside HO next State: ",$scope.submissionVM.draftData)
            //console.log("Printing inside Contact details222", $scope.questionSets)
            //This is hardcoded to Oregon
            //$scope.submissionVM.draftData.policyAddress.county = "OR";
            //console.log("Scope Address", $scope.address)
            //console.log("Print Form ", form)
            // console.log("Print Form valid", form.valid)

            form.submitted =true;

            

            if (!form.valid) {
                //console.log("Invalid form inside HO next State")
                return;
            }
            else {
                // $scope.saveQuote();
                ctrl.next(form)
            }
        };
        //ENHC0011961 - adding membership attention message ---Arpita Sengupta
        ctrl.showMemberWarning = function (){

            if(null != $scope.membershipDetails.membershipNumber && $scope.membershipDetails.membershipNumber != '' && $scope.membershipDetails.membershipNumber.length !=16) {
        
                ModalService.showCustomInfo('quoteandbind.controllers.ModalService.Attention',
                    'quoteandbind.controllers.MembershipCtrl.AttentionMessage');
            }
        
        };
        //ENHC0011961 - checking validation for Membership number - Arpita Sengupta
        ctrl.checkMembershipNum = function() {
            if ($scope.membershipDetails.membershipNumber != null && $scope.membershipDetails.membershipNumber != '' && $scope.membershipDetails.membershipNumber.length == '16'  ) {

                var membershipPromise = MembershipService.isMember('quoteandbind', $scope.membershipDetails);
                ModalService.showProgressDialog('quoteandbind.controllers.MembershipCtrl.Checking for membership', membershipPromise);
        
                membershipPromise.then(membershipResp => {
        
                    if( membershipResp[0].membershipStatus &&
                        membershipResp[0].firstName && membershipResp[0].lastName
                    ){
                        $scope.accountHolder.membershipNumber = membershipResp[0].membershipNumber;
                        $scope.accountHolder.joinedYear = membershipResp[0].originalJoinYear;
                        $scope.accountHolder.membershipType = membershipResp[0].serviceLevel;
                        $scope.accountHolder.membershipStatus = membershipResp[0].membershipStatus;
                        $scope.accountHolder.firstName = membershipResp[0].firstName;
                        $scope.accountHolder.lastName = membershipResp[0].lastName;
                        $scope.accountHolder.Address1 = membershipResp[0].Address1 ? membershipResp[0].Address1:'' ;
                        $scope.accountHolder.Email = membershipResp[0].Email ? membershipResp[0].Email:'' ;
                        $scope.accountHolder.PhoneNumber = membershipResp[0].PhoneNumber ? membershipResp[0].PhoneNumber:'' ;
        
                    }
                    $scope.accountHolder.isMember = true;
        
                }).catch(() => {
                    personalDetailsUpdate()                    
                    const errorPromise = ModalService.showError(
                        'quoteandbind.controllers.MembershipCtrl.Error',
                        'quoteandbind.controllers.MembershipCtrl.PC system down error'
                    );
                });
        
            }else{
                personalDetailsUpdate();
            }
        //ended
        }
        const personalDetailsUpdate = () => {
            ['membershipNumber', 
            'joinedYear', 
            'membershipType',
            'membershipStatus',
            'firstName',
            'lastName',
            'Address1',
            'Email',
            'PhoneNumber'].forEach(accountHolderData => delete $scope.accountHolder[accountHolderData]);
        }
        return ctrl.create($scope);
    };
    fn.$inject = ['$scope', '$state', '$rootScope', '$filter', 'ModalService', 'AgeAllowedToDrive', 'submissionViewModel', 'StateUtils', 'LocaleService','MembershipService','qnb.InputValidationService'];

    return fn;
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/pa/controllers/PAContactDetailsCtrl.js
 **/